// ** Type Imports
import { PaletteMode } from '@mui/material';
import { common } from '@mui/material/colors';

// Primary colours
 const primary = '#1E78FF';
 const primaryLight = '#DFECFF';

// Text colours
 const textPrimary = '#26262B';
 const textSecondary = '#586478';
 const textTertiary = '#9CA3AF';
 const textDisabled = '#DADADA';

// Status colours
 const error = '#F50F4A';
 const errorLight = '#FDCFDB';
 const warning = '#FFA945';
 const warningLight = '#FFF5E9';
 const success = '#369987';
 const successLight = '#D7EBE7';
 const info = '#1E78FF';
 const infoLight = '#DFECFF';
 const infoLightest = '#F1F7FF';

declare module '@mui/material/styles' {
  interface Palette {
    tertiary: Palette['secondary'];
  }

  interface PaletteOptions {
    tertiary: PaletteOptions['secondary'];
  }
}

const DefaultPalette = (mode: PaletteMode) => {
  return {
    primary: {
      main: primary,
      light: primaryLight,
      contrastText: '#ececec',
    },
    secondary: {
      main: common.black,
      contrastText: common.white,
    },
    tertiary: {
      main: '#D1D5DB',
    },
    background: {
      default: '#ffffff',
      paper: '#ffffff',
    },
    error: {
      main: error,
      light: errorLight,
    },
    warning: {
      main: warning,
      light: warningLight,
    },
    success: {
      main: success,
      light: successLight,
    },
    info: {
      dark: info,
      main: infoLight,
      light: infoLightest,
    },
    text: {
      primary: textPrimary,
      secondary: textSecondary,
      tertiary: textTertiary,
      disabled: textDisabled,
    },
    selected: {
      main: primary,
      light: primaryLight,
      contrastText: '#ececec',
    },
  };
};

export default DefaultPalette;
